import { Component, OnInit } from '@angular/core';
import { ApplicationContextService } from 'lib-core-shared';

@Component({
  selector: 'lib-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css']
})
export class TopBarComponent implements OnInit {
  isVisible: boolean = this.context.isApplicationEmbedded() ? false : true;
  brandLogo: string = this.context.getBrandContextFromUrl() == 'MOSS' ? 'https://cdn.sngbarratt.com/images/partners/MOSS_logo.svg' : 'https://www.sngbarratt.com/assets/img/sng-logo-mono-black.svg'

  constructor(
    private context: ApplicationContextService
  ) {
  }

  ngOnInit(): void {}
}
